import { Badge, HStack } from '@chakra-ui/react'
import { useTranslation } from '../../i18n'

// What an account can do, as words (never colour alone). Shared by the users
// list and the user page's header.
export function UserBadges({ user }) {
    const { t } = useTranslation()
    const badges = []
    if (user.sysadmin) badges.push({ key: 'sys', label: t('users.badgeSysadmin'), palette: 'brand' })
    if (user.salesRole === 'seller') badges.push({ key: 'sales', label: t('users.badgeSeller'), palette: 'blue' })
    if (user.salesRole === 'salesmanager') badges.push({ key: 'sales', label: t('users.badgeSalesmanager'), palette: 'blue' })
    if (user.disabled) badges.push({ key: 'off', label: t('users.badgeDisabled'), palette: 'red' })
    if (badges.length === 0) return null
    return (
        <HStack gap={1} wrap="wrap">
            {badges.map((b) => (
                <Badge key={b.key} size="sm" variant="subtle" colorPalette={b.palette}>{b.label}</Badge>
            ))}
        </HStack>
    )
}
